/**
 * @generated SignedSource<<efd0a80ea1443bad79a800c25a2e2fb0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AutoShareToChannelsSettingsQuery$variables = {
  streamId: string;
};
export type AutoShareToChannelsSettingsQuery$data = {
  readonly stream: {
    readonly " $fragmentSpreads": FragmentRefs<"AutoShareToChannelsSettings_stream">;
  } | null;
};
export type AutoShareToChannelsSettingsQuery = {
  response: AutoShareToChannelsSettingsQuery$data;
  variables: AutoShareToChannelsSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "streamId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AutoShareToChannelsSettingsQuery",
    "selections": [
      {
        "alias": "stream",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AutoShareToChannelsSettings_stream"
              }
            ],
            "type": "NoteStream",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AutoShareToChannelsSettingsQuery",
    "selections": [
      {
        "alias": "stream",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StreamAutoShareSettings",
                "kind": "LinkedField",
                "name": "autoShareSettings",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "channels",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isPrivate",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "NoteStream",
            "abstractKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "93ed9e17c4ce47184c9e43c1b6379539",
    "id": null,
    "metadata": {},
    "name": "AutoShareToChannelsSettingsQuery",
    "operationKind": "query",
    "text": "query AutoShareToChannelsSettingsQuery(\n  $streamId: ID!\n) {\n  stream: node(id: $streamId) {\n    __typename\n    ... on NoteStream {\n      ...AutoShareToChannelsSettings_stream\n    }\n    id\n  }\n}\n\nfragment AutoShareToChannelsSettings_stream on NoteStream {\n  autoShareSettings {\n    id\n    enabled\n    channels {\n      __typename\n      id\n      name\n      isPrivate\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d9f7b8a4b854cad6dd338f9664a148c0";

export default node;
